export default __webpack_public_path__ + "static/media/battery-power.3c01b8a3.svg";